// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    getAllAvailableColumns,
    getAvailableColumns
} from '../../../shared/services/available-excel-columns';
import CreateClaimModal from '../../../shared/components/create-claim-modal';
import CreateClaimModalType from '../../../shared/state/create-claim-modal';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import CustomerSearch2Panel from '../../../shared/components/customer-search-panel/customer-search-2.js';
import ExcelLayoutHeaderBar from '../../../shared/components/excel-layout/excel-layout-header-bar';
import ExcelLayoutModal from '../../../shared/components/excel-layout/excel-layout-modal';
import ExportToExcel from '../../../shared/state/export-to-excel';
import {FormattedMessage} from 'react-intl';
import Modal from '../../shared/state/modal';
import ProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import ProductsList from './products-list';
import SearchFilters from '../../shared/state/search-filters';
import StatusChangeRequestModal from '../../shared/components/status-change-request-modal/status-change-request-modal';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToExcel} from '../../../shared/services/export-to-excel';
import {getProductSearchColumns} from '../../search/services/excel-columns';
import {getSortByList} from '../../../shared/services/get-excel-layout-modal-sort-by-list';

function handleCreateCustomerClick(ckcId) {

    this.actions.readCustomer(ckcId);
    this.actions.readProductsByCustomer(ckcId);

}

function handleUpdateCustomerEditModalVisibility(visibility) {

    this.actions.updateCustomerEditModalVisibility(visibility);

}

function handleUpdateCustomerSearchModalVisibility(visibility) {

    this.actions.updateCustomerSearchModalVisibility(visibility);

}

function handleSearchFiltersUpdate(property, value) {

    this.actions.updateSearchFilters(property, value);

}

function handleCreateClaimModalVisibilityUpdate(isOpen, pin) {

    this.actions.updateCreateClaimModalVisibility(isOpen, pin);

}

function handleProductUpdate(product) {

    this.actions.updateProduct(product);

}

function handleStatusChangeModalVisibilityUpdate(isVisible) {

    this.actions.updateStatusChangeModalVisibility(isVisible);

}

function handleCreateClaim(claimKey, pin) {

    this.actions.onCreateClaim(claimKey, pin);

}

function closeCreateClaimModal() {

    this.actions.updateCreateClaimModalVisibility(false);

}

function handleCloseStatusChangeModal() {

    this.actions.updateStatusChangeModalVisibility(false);

}

function handleUpdateStatus() {

    this.actions.updateStatusChangeModalVisibility(false);
    this.actions.goToStatusChangeRequestView(this.product.pin);

}

function handleCreateExcelLayout() {

    const availableColumns = getAllAvailableColumns('productSearch');

    this.actions.updateExcelLayoutModalExcelLayout(true);
    this.actions.updateExcelLayoutModalIsNewLayout(true, 'productSearch');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

    if (!this.exportToExcel.excelLayouts.productSearch.length) {

        this.actions.updateExcelLayoutModalExcelLayoutIsDefault(true);

    }

    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleEditExcelLayout() {

    const availableColumns = getAvailableColumns('productSearch', this.exportToExcel.selectedExcelLayout.productSearch.columns);

    this.actions.updateExcelLayoutModalExcelLayout(false, this.exportToExcel.selectedExcelLayout.productSearch);
    this.actions.updateExcelLayoutModalIsNewLayout(false, 'productSearch');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);
    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleExcelLayoutChange(selectedLayout) {

    const availableColumns = getAvailableColumns('productSearch', selectedLayout.columns);

    this.actions.updateSelectedExcelLayout(selectedLayout, 'productSearch');
    this.actions.updateExcelLayoutModalExcelLayout(false, selectedLayout);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

}

function handleColumnMove(dragIndex, hoverIndex, listId, dragCard) {

    listId === 'available-items' ?
        this.actions.updateExcelLayoutModalAvailableColumnsOrder(dragIndex, hoverIndex, dragCard) :
        this.actions.updateExcelLayoutModalExcelLayoutColumnsOrder(dragIndex, hoverIndex, dragCard);

}

function handleColumnPush(column, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.pushExcelLayoutModalExcelLayoutColumn(column) :
        this.actions.pushExcelLayoutModalAvailableColumn(column);

}

function handleColumnRemove(index, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.removeExcelLayoutModalAvailableColumn(index) :
        this.actions.removeExcelLayoutModalExcelLayoutColumn(index);

}

function handleExcelLayoutDelete() {

    this.actions.deleteExcelLayout(this.exportToExcel.selectedExcelLayout.productSearch.name, this.exportToExcel.selectedExcelLayout.productSearch.listId, 'productSearch');

}

function handleLayoutNameBlur(layoutName) {

    const nameAlreadyExists = this.exportToExcel.excelLayouts.productSearch.some(layout => layout.name === layoutName);

    nameAlreadyExists ?
        this.actions.updateExcelLayoutModalIsNameValid(false) :
        this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleLayoutNameChange(layoutName) {

    this.actions.updateExcelLayoutModalLayoutName(layoutName);

}

function handleExcelLayoutModalClose() {

    this.actions.updateExcelLayoutModalVisibility(false);
    this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleSaveExcelLayout() {

    this.actions.saveExcelLayout(this.exportToExcel.excelLayoutModal.excelLayout, 'productSearch');

}

function handleSetAsDefaultChange(isSelected) {

    this.actions.updateExcelLayoutModalExcelLayoutIsDefault(isSelected);

}

function handleExcelSortByChange(sortByColumn) {

    this.actions.updateExcelLayoutModalExcelLayoutSortBy(sortByColumn, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleExcelSortDirectionChange(sortDirection) {

    this.actions.updateExcelLayoutModalExcelLayoutSortDirection(sortDirection, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

class ProductsByCustomer extends Component {

    componentWillMount() {

        this.props.actions.getClaimTypesList();

        if (this.props.queryParams.ckcId) {

            if (this.props.queryParams.ckcId !== this.props.customer.ckcId) {

                this.props.actions.resetCustomer();
                this.props.actions.resetProductsByCustomer();
                this.props.actions.readCustomer(this.props.queryParams.ckcId);
                this.props.actions.readProductsByCustomer(this.props.queryParams.ckcId);

            }

        } else if (!this.props.customer.displayName) {

            this.props.actions.updateCustomerSearchModalVisibility(true);

        }

    }

    componentWillUnmount() {

        this.props.actions.updateCustomerEditModalVisibility(false);
        this.props.actions.updateCustomerSearchModalVisibility(false);
        this.props.actions.updateCreateClaimModalVisibility(false, '');
        this.props.actions.resetProduct();
        this.props.actions.updateStatusChangeModalVisibility(false);

    }

    render() {

        return (
            <div className='products-by-customer'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside>
                    <CustomerSearch2Panel
                        customer={this.props.customer}
                        isCustomerEditModalOpen={this.props.isCustomerEditModalOpen}
                        isCustomerSearchModalOpen={this.props.isCustomerSearchModalOpen}
                        onCreateCustomerClick={this.props::handleCreateCustomerClick}
                        onCustomerEdit={this.props::handleCreateCustomerClick}
                        updateCustomerEditModalVisibility={this.props::handleUpdateCustomerEditModalVisibility}
                        updateCustomerSearchModalVisibility={this.props::handleUpdateCustomerSearchModalVisibility}
                    />
                </aside>
                <main>
                    <div className='primary-actions'>
                        {this.props.products.length > 0 &&
                            <div className='export-functions'>
                                <ExcelLayoutHeaderBar
                                    excelLayouts={this.props.exportToExcel.excelLayouts.productSearch}
                                    onCreateLayout={this.props::handleCreateExcelLayout}
                                    onEditLayout={this.props::handleEditExcelLayout}
                                    onLayoutChange={this.props::handleExcelLayoutChange}
                                    selectedLayout={this.props.exportToExcel.selectedExcelLayout.productSearch}
                                />
                                <div className='export-excel'>
                                    <button
                                        onClick={() => exportToExcel(`/api/products/search?by=CUSTOMER&q=${this.props.customer.ckcId}&export=EXCEL&language=${this.props.user.getLocale()}&layout=${encodeURIComponent(this.props.exportToExcel.selectedExcelLayout.productSearch.name)}&listId=productSearch`)}
                                    >
                                        <FormattedMessage id='EXPORT'/>
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                    <ProductsList
                        ckcId={this.props.customer.ckcId}
                        exportToExcel={this.props.exportToExcel}
                        onUpdateSearchFilters={this.props::handleSearchFiltersUpdate}
                        partialData={this.props.partialData}
                        products={this.props.products}
                        searchFilters={this.props.searchFilters}
                        updateCreateClaimModalVisibility={this.props::handleCreateClaimModalVisibilityUpdate}
                        updateProduct={this.props::handleProductUpdate}
                        updateStatusChangeModalVisibility={this.props::handleStatusChangeModalVisibilityUpdate}
                        userLanguage={this.props.user.getLocale()}
                    />
                </main>
                <CreateClaimModal
                    claimTypes={this.props.createClaimModal.claimTypes}
                    isModalOpen={this.props.createClaimModal.isModalOpen}
                    onClick={this.props::handleCreateClaim}
                    onCloseButtonClick={this.props::closeCreateClaimModal}
                    selectedPin={this.props.createClaimModal.selectedPin}
                />
                <StatusChangeRequestModal
                    changeModalVisibility={this.props::handleCloseStatusChangeModal}
                    product={this.props.product}
                    productStatusChangeModal={this.props.statusChangeModal}
                    updateStatus={this.props::handleUpdateStatus}
                />
                <ExcelLayoutModal
                    excelLayoutModal={this.props.exportToExcel.excelLayoutModal}
                    mappingTable={getProductSearchColumns().listColumns}
                    onColumnMove={this.props::handleColumnMove}
                    onColumnPush={this.props::handleColumnPush}
                    onColumnRemove={this.props::handleColumnRemove}
                    onLayoutDelete={this.props::handleExcelLayoutDelete}
                    onLayoutNameBlur={this.props::handleLayoutNameBlur}
                    onLayoutNameChange={this.props::handleLayoutNameChange}
                    onModalClose={this.props::handleExcelLayoutModalClose}
                    onSaveLayout={this.props::handleSaveExcelLayout}
                    onSetAsDefaultChange={this.props::handleSetAsDefaultChange}
                    onSortByChange={this.props::handleExcelSortByChange}
                    onSortDirectionChange={this.props::handleExcelSortDirectionChange}
                    sortByList={getSortByList(getProductSearchColumns().listColumns, this.props.exportToExcel.excelLayoutModal.excelLayout.columns)}
                />
            </div>
        );

    }

}

ProductsByCustomer.displayName = 'ProductsByCustomer';
ProductsByCustomer.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    createClaimModal: PropTypes.instanceOf(CreateClaimModalType).isRequired,
    customer: PropTypes.instanceOf(Customer).isRequired,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    isCustomerEditModalOpen: PropTypes.bool.isRequired,
    isCustomerSearchModalOpen: PropTypes.bool.isRequired,
    partialData: PropTypes.bool.isRequired,
    product: PropTypes.instanceOf(ProductSearchResult).isRequired,
    products: PropTypes.arrayOf(PropTypes.instanceOf(ProductSearchResult)).isRequired,
    queryParams: PropTypes.object.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    statusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default ProductsByCustomer;



// WEBPACK FOOTER //
// ./src/product/products-by-customer/components/index.js